import { render, staticRenderFns } from "./SocialLogin.vue?vue&type=template&id=066bafa7&"
import script from "./SocialLogin.vue?vue&type=script&lang=js&"
export * from "./SocialLogin.vue?vue&type=script&lang=js&"
import style0 from "./SocialLogin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports